import './_financial-allocations-table.scss';
import customSelects from "custom-select";

export default function FinancialAllocationsTable() {
    const financialAllocations = document.querySelectorAll('.financial-allocations-table');

    if(financialAllocations.length > 0) {
        financialAllocations.forEach(item => {

            const tabContent = item.querySelectorAll('.tab-content');
            tabContent.forEach((el, index) => {
                el.setAttribute('id', `input-tab-${index}`)
            })

            const tabs = item.querySelectorAll('.tab');
            tabs.forEach((tab, index) => {
                tab.setAttribute('for', `input-tab-${index}`)
                if(index === 0) {
                    tab.classList.add('is-active');
                    tabContent.forEach((el) => {
                        if(el.getAttribute('id') === 'input-tab-0') {
                            el.classList.add('checked')
                        }
                    })
                }

                tab.addEventListener('click', () => {
                    tabs.forEach(item => {
                        item.classList.remove('is-active');
                    });
                    tab.classList.add('is-active');
                    tabContent.forEach((el) => {
                        if(tab.getAttribute('for') === (el.getAttribute('id'))) {
                            el.classList.add('checked')
                        } else {
                            el.classList.remove('checked')
                        }
                    })
                })

                tab.addEventListener('keypress', function (e) {
                    // @ts-ignore
                    if (e.code === 'Enter') {
                        tabs.forEach(item => {
                            item.classList.remove('is-active');
                        });
                        tab.classList.add('is-active');
                        tabContent.forEach((el) => {
                            if(tab.getAttribute('for') === (el.getAttribute('id'))) {
                                el.classList.add('checked')
                            } else {
                                el.classList.remove('checked')
                            }
                        })
                    }
                })
            })

            const selectCustom = customSelects(item.querySelector('select'));

            const selectCustomCont = selectCustom[0].select.customSelect as any;
            const selectContainer = selectCustomCont.container;
            const selectPanel = selectContainer.querySelector('.custom-select-opener');
            const span = selectPanel.querySelector('span');
            const optionsCustom = Array.from(selectContainer.querySelectorAll('.custom-select-option'));
            const selectPanelId = selectPanel.getAttribute('aria-activedescendant');
            const contentMobile = item.querySelectorAll('.content-mobile');

            contentMobile.forEach((content, index) => {
                content.setAttribute('id', `tab-${index + 1}`)

                if(content.getAttribute('id') === 'tab-1') {
                    content.classList.add('show');
                }
            })

            selectPanel.addEventListener('keypress', function (e: any) {
                if (e.code === 'Enter') {
                    selectContainer.classList.toggle('is-open');
                }
            })

            optionsCustom.forEach((option: any, index: number) => {
                option.setAttribute('tabindex', '0');
                option.setAttribute('data-value', `tab-${index + 1}`)
                option.addEventListener('keypress', function (e: any) {
                    if (e.code === 'Enter') {
                        optionsCustom.forEach((item: any) => {
                            item.classList.remove('is-selected');
                            item.classList.remove('has-focus');
                            item.removeAttribute('id');
                        })
                        option.classList.add('is-selected');
                        option.classList.add('has-focus');
                        option.setAttribute('id', selectPanelId);
                        span.innerHTML = option.innerHTML;
                        selectContainer.classList.remove('is-open');

                        contentMobile.forEach(content => {
                            if(content.getAttribute('id') === option.getAttribute('data-value')) {
                                content.classList.add('show');
                            } else {
                                content.classList.remove('show');
                            }
                        })
                    }
                })

                option.addEventListener('click', () => {
                    contentMobile.forEach(content => {
                        if(content.getAttribute('id') === option.getAttribute('data-value')) {
                            content.classList.add('show');
                        } else {
                            content.classList.remove('show');
                        }
                    })
                })
            })
        })
    }
}